import Experience from "../Experience";
import HotspotGroup from "./HotspotGroup";

export default class Hotspots {
  constructor () {
    this.experience = new Experience();

    const hotspots = this.experience.params.hotspots;

    this.hybrid = new HotspotGroup(hotspots.hybrid);
    this.tower = new HotspotGroup(hotspots.tower);
    this.towerInterior = new HotspotGroup(hotspots.towerInterior);
    this.cameraCoverage = new HotspotGroup(hotspots.cameraCoverage);
    this.growth = new HotspotGroup(hotspots.growth);

    this.setListeners();
  }

  setListeners () {
    this.hybrid.on("click", (hotspot) => {
      this.experience.world.drawers.open(hotspot);
      this.experience.world.labels.show(hotspot);
      this.experience.world.overlays.show(hotspot);
    });

    this.growth.on("click", (hotspot) => {
      this.experience.world.drawers.open(hotspot);
    });

    this.towerInterior.on("click", (hotspot) => {
      this.experience.world.drawers.open(hotspot);
    });

    this.tower.on("click", (hotspot) => {
      this.experience.world.enterTower(hotspot);
    });

    this.cameraCoverage.on("click", (hotspot) => {
      this.experience.world.drawers.open(hotspot);

      this.experience.world.overlays.show(hotspot);
    });
  }

  setInactive () {
    const active = document.querySelector(".hotspot[data-state='active']");

    if (active) active.dataset.state = "visible";
  }
}